// eslint-disable-next-line no-unused-vars
class $$ {
	constructor(selector, where = document) {
		this.self = where.querySelector(selector);
		this.elems = where.querySelectorAll(selector);
	}

	each(callback) {
		this.elems.forEach((elem, elemIndex) => callback(elem, elemIndex));
	}

	on(event, callback) {
		this.elems.forEach((elem, elemIndex) => {
			elem.addEventListener(event, () => callback(elem, elemIndex));
		});
	}
}
